export function showNotification(notification) {
  const container = document.getElementById("notifications-list");
  if (!container) return;

  const link = document.createElement("a");
  link.href = notification.href || "#";
  link.className = "list-group-item list-group-item-action border-bottom";

  link.innerHTML = `
        <div class="row align-items-center">
            <div class="col ps-0 ms-2">
                <div class="d-flex justify-content-between align-items-center">
                    <div>
                        <h4 class="h6 mb-0 text-small">${notification.title}</h4>
                    </div>
                    <div class="text-end">
                        <small>${notification.time}</small>
                    </div>
                </div>
                <p class="font-small mt-1 mb-0">${notification.message}</p>
            </div>
        </div>
    `;

  // Neue Nachricht nach oben einfügen
  container.insertBefore(link, container.firstChild);

  // Maximal 6 Elemente behalten (alles darüber entfernen)
  while (container.children.length > 6) {
    container.removeChild(container.lastElementChild);
  }

  const bell = document.getElementsByClassName("notification-bell")[0];
  bell.classList.add("unread");
}
